<template>
  <div id="map" class="o-echarts" style="width: 700px; margin: 10px auto; height: 600px; "  data-ratio="16:9"></div>
</template>

<script>
  import taizhouJSON from './province/json/taizhou.json';
  import chinaJSON from './province/json/china.json'
  import shandongJSON from './province/json/shandong.json'
  import jiangsuJSON from './province/json/jiangsu.json'
  import jinanJSON from './province/json/jinan'
  import nanjingJSON from './province/json/nanjing.json'
  import loopShowTooltip from '../../../assets/js/cycleHighLight'
  export default {
    name: 'HomeMap2',
    props: ['areaName'],
    // prop
    data(){
      return {
        cityMap:{
          中国:chinaJSON,
          山东省:shandongJSON,
          江苏省:jiangsuJSON,
          济南市:jinanJSON,
          泰州市:taizhouJSON
        },
        interval:null, // 轮询
        chosenJSON:nanjingJSON,
        // id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),

      }
    },
    created () {
      this.$nextTick(() => {
        // 使用vue.$nextTick()方法可以在dom数据更新后延迟执行
        this.initMap();
      });
    },
    methods: {
      // 判断数组相等(特殊，不能直接比较)
      // arraySame(arr1, arr2){
      //   let res = true;
      //   if(arr1.length !== arr2.length){
      //     res = false;
      //   }
      //   else{
      //     for(let i = 0;i < arr1.length; i++){
      //       if(arr1[i].areaId !== arr2[i].areaId){
      //         res = false;
      //         break;
      //       }
      //       if(arr1[i].CENum !== arr2[i].CENum){
      //         res = false;
      //         break;
      //       }
      //       if(arr1[i].onlineNum !== arr2[i].onlineNum){
      //         res = false;
      //         break;
      //       }
      //       if(arr1[i].onNum !== arr2[i].onNum){
      //         res = false;
      //         break;
      //       }
      //       if(arr1[i].alarmNum !== arr2[i].alarmNum){
      //         res = false;
      //         break;
      //       }
      //     }
      //   }
      //
      //   return res;
      // },

      initMap(){
        this.$echarts.registerMap(name, this.chosenJSON);
        let echartObj = this.$echarts.init(document.getElementById('map'));
        let option = {
          geo: {
            //地理坐标系组件用于地图的绘制，支持在地理坐标系上绘制散点图，线集。
            //zoom: 1, //默认视角的缩放比例
            roam: true, //是否开启平移和缩放，可单独开启
            // scaleLimit: {
            //   //滚轮缩放的极限控制
            //   min: 1,
            //   max: 4,
            // },
            itemStyle: {
              //地图色彩设置
              areaColor: '#20389c',
              borderColor: '#0971c9',
            },
            emphasis: {
              //高亮状态下的多边形和标签样式。
              itemStyle: {
                areaColor: "#067ec5", //高亮状态下的地图区域的背景色
              },
            },
            label: {
              // 标签的显示
              //就是地区名的样式
              normal: { show: true, color: "#fff" },
              emphasis: { show: true, color: "#fff" },
            },
          },
          series: [
            {
              type: "map",
              geoIndex: 0, //指定geo组件
              data:""
            },
          ],
        };

        // echartObj.showLoading();
        echartObj.setOption(option);
        // setTimeout(() => {
        //   echartObj.hideLoading();
        // }, 500);
        let _this = this;
        echartObj.on('click',function(params){
            console.log(params);
            console.log(_this.cityMap)
            if(_this.cityMap[params.name]){
              if (_this.chosenJSON != _this.cityMap[params.name]) {
                _this.chosenJSON = _this.cityMap[params.name];
                _this.$echarts.registerMap(name, _this.chosenJSON);
                echartObj.setOption(option,true);
              }
            }
          },
          echartObj.getZr().on("click", (params) => {
            // echarts点击空白事件
            // 返回一级，重庆市
            if (params.target == undefined) {
              _this.chosenJSON = _this.cityMap["中国"];
              _this.$echarts.registerMap(name, _this.chosenJSON);
              echartObj.setOption(option, true);
            }
          })
        )
      },
    },
  }
</script>

<style scoped>
  #homeMap{
    width: 100%;
    height: auto;
  }
  .o-echarts {
    min-width: 30px;
    min-height: 30px;
    width: 100%;
    height: 100%;
  }
</style>
<!--<style lang="less">-->
<!--.o-echarts {-->
<!--min-width: 30px;-->
<!--min-height: 30px;-->
<!--width: 100%;-->
<!--height: 100%;-->
<!--}-->
<!--</style>-->
